<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>
<script>
export default {
  name: 'App',
  components: {}
}
</script>

<style lang="scss" >
  @import './assets/iconfont/iconfont.css';
  @import './style/common';
</style>



// WEBPACK FOOTER //
// src/App.vue